import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const allSociety = createAsyncThunk("allSociety", async (data) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    const response = await AxiosInstance.get(
      `${API_KEY}/api/society/all`,

      {
        headers: {
          Authorization: `Barear ${token}`,
        },
        "Content-Type": "application/json",
      }
    );

    return response;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  allSocietyData: null,
  isError: false,
  errorMessage: "",
};
const allSocietySlice = createSlice({
  name: "allSociety",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(allSociety.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(allSociety.fulfilled, (state, action) => {
      state.isLoading = false;
      state.allSocietyData = action.payload;
    });
    builder.addCase(allSociety.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default allSocietySlice.reducer;
